import { render } from "./LoginChoose.vue?vue&type=template&id=53bedd2e&scoped=true"
import script from "./LoginChoose.vue?vue&type=script&lang=js"
export * from "./LoginChoose.vue?vue&type=script&lang=js"

import "./LoginChoose.vue?vue&type=style&index=0&id=53bedd2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bedd2e"]])

export default __exports__